// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"bcf6ce4d","218":"d0febfac","253":"a54fa065","257":"499aa75e","328":"2995c171","503":"6972f49b","744":"ddc4ab9f","787":"93c29abf","957":"d7bfc062"}[chunkId] + ".chunk.js";
};